import type { OfferPositionType } from '~/prisma/enums'

const offerPositionTypesToNotGroupByDay = new Set<OfferPositionType>(['extraDays', 'insurance'])

export default (offerPosition: { unit: string, type: OfferPositionType }) => offerPosition.unit === 'day' && !(offerPositionTypesToNotGroupByDay).has(offerPosition.type)
